<template>
  <div>
    <b-modal size="md" class="modal-size" hide-footer v-model="modal_beds" title="Camas">
      <b-row>
        <b-col md="12">
          <b-form-group label="Buscar:">
            <b-form-input autofocus @keyup="SearchBeds" type="search" v-model="search" ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <div  class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="10%" class="text-center">#</th>
                    <th width="55%" class="text-center">Nombre</th>
                    <th width="25%" class="text-center">Cantidad</th>
                    <th width="10%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in beds" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-left">{{ item.name }}</td>
                    <td class="text-left">
                      <b-form-input  type="number" v-model="item.quantity"></b-form-input>
                    </td>
                    <td class="text-center">
                      <b-button type="button" @click="AddBed(it)" variant="primary" ><i class="fas fa-plus-circle"></i></b-button >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import EventBus from "@/assets/js/EventBus";
export default {
  name: "ModalClient",
  components:{

  },
  data() {
    return {
        module: 'RoomType',
        role:2,
        modal_beds: false,
        search:'',
        beds:[]
      
    };
  },
  created (){
    this.SearchBeds();
  },
  mounted () {
    EventBus.$on('ModalBedsShow', (role) => {
      this.role = role;
      this.modal_beds = true;
    });
  },
  methods: {
    SearchBeds,
    AddBed,
  },
  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    }
  },
};

function SearchBeds() {
  let me = this;
  let url = me.url_base + "search-beds";
  let data = {search : me.search};
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json",token: me.token, module: me.module,role: me.role},
  })
    .then(function (response) {
      if (response.data.status == 200) {
       me.beds = response.data.result;
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

function AddBed(index) {
    this.beds[index].quantity = this.beds[index].quantity.length == 0 ? 1:this.beds[index].quantity;
    let data = {
      id_bed:this.beds[index].id_bed,
      name:this.beds[index].name,
      photo:this.beds[index].photo,
      quantity:this.beds[index].quantity,
    }
     EventBus.$emit('AddBeds',data);
}
</script>
